export const DEFAULT_DATE = '';
export const DEFAULT_TIME = '00:00:00';
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_TIME_FORMAT = 'HH:mm:ss';
export const DEFAULT_DISPLAY_TIME_FORMAT = 'HH:mm';
export const DEFAULT_DIALOG_WIDTH = 340;
export const DEFAULT_CLEAR_TEXT = 'CLEAR';
export const DEFAULT_OK_TEXT = 'OK';

export const getDefaultDateTimeFormat = () => `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;
